<div class="flex gap-1">
    <div class="w-2 h-2 rounded-full animate-pulse bg-iota-inh-green"></div>
    <div class="w-2 h-2 rounded-full animate-pulse bg-iota-inh-green"></div>
    <div class="w-2 h-2 rounded-full animate-pulse bg-iota-inh-green"></div>
</div>
